import { render, staticRenderFns } from "./labeling12911.vue?vue&type=template&id=08cdbd88&scoped=true&"
import script from "./labeling12911.vue?vue&type=script&lang=js&"
export * from "./labeling12911.vue?vue&type=script&lang=js&"
import style0 from "./labeling12911.vue?vue&type=style&index=0&id=08cdbd88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cdbd88",
  null
  
)

export default component.exports